import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { DateRange, MultiSelect } from '@Components/Filters';
import { getPurchaseClassifications } from '@Store/selectors/dictionarySelector';
import { getStatusLabels } from '../store/selectors/purchaseRequestSelector';

import { FilterForm } from './types';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const statuses = useAppSelector(getStatusLabels);
  const purchaseClassifications = useAppSelector(getPurchaseClassifications);
  const classificationTypeLabels = purchaseClassifications.map(
    (classification) => classification.codeDesc
  );

  const items: CollapseProps['items'] = [
    {
      id: 'DATE RANGE',
      label: 'Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="dateFrom"
          toKey="dateTo"
        />
      ),
    },
    {
      id: 'CLASSIFICATION',
      label: 'Classification',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="classifications"
          options={classificationTypeLabels}
        />
      ),
    },
    {
      id: 'STATUS',
      label: 'Status',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="statuses"
          options={statuses}
          showSearch
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
